import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Input } from '@/components/form';

interface MyPickerProps {
  label?: React.ReactNode;
  subLabel?: string;
  helperText?: string;
  error?: boolean;
  value: string;
  className?: string;
  placeholder?: string;
  sx?: React.CSSProperties;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  onChange?: (value: string) => void;
}

const MyTimePicker = (props: MyPickerProps) => {
  const {
    value,
    label,
    subLabel,
    helperText,
    error,
    className,
    placeholder,
    startAdornment,
    sx,
    onChange,
  } = props;
  const [open, setOpen] = React.useState(false);
  const inputRef = React.useRef<HTMLDivElement | null>(null);
  const handleChange = (newValue: string) => {
    onChange && onChange(newValue);
  };
  const renderInput = (params: any) => {
    return (
      <Input
        {...params.InputProps}
        {...params.inputProps}
        myInputRef={inputRef}
        inputRef={params.inputRef}
        readOnly
        className={className}
        label={label}
        subLabel={subLabel}
        error={error}
        helperText={helperText}
        placeholder={placeholder}
        startAdornment={startAdornment}
        sx={sx}
        onClick={() => setOpen(true)}
      />
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        open={open}
        value={value ?? null}
        onChange={(newValue) => handleChange(newValue as string)}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setTimeout(() => inputRef.current?.blur(), 5);
        }}
        closeOnSelect={true}
        renderInput={renderInput}
        desktopModeMediaQuery=""
      />
    </LocalizationProvider>
  );
};

export default MyTimePicker;
